import { Box, CardMedia, Typography } from '@mui/material'
import React from 'react'
import logo from './../../assets/footer/logo.png'
const Logo = ({  bio }) => { // logo
    return (
        <>
            <Box sx={{
                position: 'relative', zIndex: 2, width: '100%',
                mb: 1,
                mt: 6
            }}>
                <CardMedia component={'img'} src={logo} className={'nav-logo'} sx={{
                    width: 'fit-content',
                    objectFit: 'cover',
                }} />
                <Typography color='footer.link' fontWeight={500}
                    sx={{ position: 'relative', zIndex: 3, mt: 2 }} >
                    {bio}
                </Typography>
            </Box>
        </>
    )
}

export default Logo